
<div class="container">

<h2 class="content-heading">
  Season
</h2>

<div class="table-responsive table yearDataTable" xclass="table table-striped table-vcenter table-sm" *ngIf="isLoading == false">

    <div class="xrow header gridRow row">
      <div class="col-md-5">Name</div>
      <div class="col-md-6">Description</div>
      <div class="col-md-1">Actions</div>
    </div>

    <div id="scrollableTable">

      <div *ngFor="let obj of data" class="dateRow gridRow row">

        <div class="col-md-5">{{obj.Localized[0].Name}}</div>
        <div class="col-md-6">{{obj.Localized[0].Description}}</div>
        <div class="col-md-1">
          <div class="btn-group">
            <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Edit" (click)="edit(obj)">
                <i class="fa fa-pencil"></i>
            </button>
          </div>
        </div>
      </div>

    </div>

  </div>

  <app-progress-bar *ngIf="isLoading==true"></app-progress-bar>

</div>


